import React from 'react';
import PropTypes from 'prop-types';
import makeRequest from 'utils/makeRequest';
import Card from 'components_v2/common/CardV2';
// import Listingheader from '../../common/ListingheaderV2';
import s from './EtimesPhotosWidget.scss';

class EtimesPhotosWidget extends React.Component {
  constructor() {
    super();
    this.state = {};
  }
  componentDidMount() {
    const { data } = this.props;
    if (data && data.dataUrl) {
      this.loadSectionData(data.dataUrl);
    }
  }

  loadSectionData = dataUrl => {
    if (!dataUrl) {
      return;
    }

    makeRequest
      .get(dataUrl, { isMobile: false }, 'skipfeedengine')
      .then(data => {
        if (
          data &&
          data.data &&
          data.data.items &&
          data.data.items.length > 0
        ) {
          //console.log('data : ', data.data);
          this.setState({
            data: { ...this.props.data, ...data.data },
          });
        }
      });
  };
  render() {
    const data = this.state.data || this.props.data;
    const { ga4Type, ga4Category } = this.props;

    if (!(data && data.items instanceof Array)) {
      return null;
    }

    const scrollGAAttr = {
      ...(data.onScrollGA && data.id && { 'data-scrollga': data.id }),
    };
    return (
      <>
        <div className={`${s.EtimesWidget}`} {...scrollGAAttr}>
          {/* <Listingheader
            headingname={data.name}
            headingLink={data.path}
            size="small"
            newga={`${data.name}Section_Actions#HeadingClick`}
          /> */}
          <div className={`${s.nonGrid} `}>
            {data.items instanceof Array
              ? data.items.map((item, index) => (
                  <div className={s.cards}>
                    <Card
                      data={item}
                      isVerticalTile
                      key={item.id || `${item.tn}_${index}`}
                      cssObj={{
                        imgCont: s.onebyoneCard,
                        titleCont: s.titlefont,
                      }}
                      newga={`${data.name}Section_Actions#$typeClick-${index +
                        1}/${item.wu}`}
                      itemClass={`${s.cardbtmspacing}`}
                      ga4Type={ga4Type}
                      ga4Category={ga4Category}
                      gaIndex={index + 1}
                    />
                  </div>
                ))
              : null}
          </div>
        </div>
      </>
    );
  }
}

EtimesPhotosWidget.propTypes = {
  data: PropTypes.shape({}),
  ga4Type: PropTypes.string,
  ga4Category: PropTypes.string,
};
EtimesPhotosWidget.defaultProps = {
  data: {},
  ga4Type: '',
  ga4Category: '',
};

export default EtimesPhotosWidget;
